import * as React from 'react';
import {connect} from "react-redux";
import {disconnectInstance} from "../actions/ioActions";

import LogoutComponent from "../components/LogoutComponent/LogoutComponent";

export interface ILogoutProps {
    dispatchDisconnectInstance: () => any,
    history: any,
}

class LogoutContainer extends React.PureComponent<ILogoutProps> {
    public render() {
        return (
            <LogoutComponent {...this.props}/>
        );
    }
}

const mapDispatchToProps = {
    dispatchDisconnectInstance: disconnectInstance
};

export default connect(null, mapDispatchToProps)(LogoutContainer);


// WEBPACK FOOTER //
// ./src/containers/LogoutContainer.tsx